function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8975"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8971"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8476",
    transform: "translate(2)",
    style: {
      stroke: "#707070",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 16,
    rx: 0.75,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.5,
    height: 15,
    rx: 0.25,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 48",
    d: "M4.536 1.161a.5.5 0 0 1 .928 0l4.262 10.653a.5.5 0 0 1-.464.686H.739a.5.5 0 0 1-.464-.686z",
    transform: "rotate(90 8 8)",
    style: {
      fill: "#9da7b2"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagicon);
export default __webpack_public_path__ + "static/media/flagicon.f60b4e5b9d6b08a79ee208df606f1b51.svg";
export { ForwardRef as ReactComponent };